var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.styles.navItem,attrs:{"href":_vm.href}},[_c('i',{staticClass:"material-icons",class:_vm.styles.navIcon},[_vm._v(_vm._s(_vm.module.icon))]),_c('span',{class:_vm.styles.navLabel},[_vm._v(_vm._s(_vm.module.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }